import axiosInstance from "../axiosInterceptor";

export async function validatePromocode(body) {
  const response = await axiosInstance.post(`student/applyCode`, body);
  const data = response?.data;
  return data;
}
